import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
} from '@angular/common/http';

import { catchError, tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {SharedService} from '../shared/shared-service';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private spinner: NgxSpinnerService,
              private cookieService: CookieService,
              private sharedService: SharedService) {
  }

  private totalRequests = 0;

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.indexOf('livelocationtracking') < 0 && request.url.indexOf('maps.googleapis.com') < 0) {
      this.totalRequests++;
      this.spinner.show();
    }
    let dupReq = null;
    const userLevel = this.sharedService.getUserDataFromSessionStorage() ? this.sharedService.getUserDataFromSessionStorage().level : null;
    if (userLevel === 1 && this.sharedService.currentOrganisation._id) {
      if (request.url.indexOf('?') === -1) {
        dupReq = request.clone({url: request.url + '?orgId=' + this.sharedService.currentOrganisation._id});
      } else {
        dupReq = request.clone({url: request.url + '&orgId=' + this.sharedService.currentOrganisation._id});
      }
    }

    if (!dupReq) {
      dupReq = request.clone();
    }

    return next.handle(dupReq).pipe(
      tap(res => {
        if (res instanceof HttpResponse) {
          this.decreaseRequests(res);
        }
      }),
      catchError(err => {
        this.decreaseRequests(err);
        if (err.status === 401) {
          this.cookieService.delete('authToken');
          sessionStorage.removeItem('userInfo');
          this.router.navigate(['/signin']);
        }
        throw err;
      })
    );
  }

  private decreaseRequests(request) {
    if (request.url.indexOf('livelocationtracking') < 0 && request.url.indexOf('maps.googleapis.com') < 0) {
      this.totalRequests--;
      if (this.totalRequests <= 0) {
        this.spinner.hide();
      }
    }
  }

}
